Object.defineProperty(exports,"__esModule",{value:true});exports.
continuousTransitions=continuousTransitions;exports.













discreteTransitions=discreteTransitions;function continuousTransitions(){return{onLoad:{duration:2000},onExit:{duration:500},onEnter:{duration:500}};}function discreteTransitions(){
return{
onLoad:{
duration:2000,
before:function before(){return{opacity:0};},
after:function after(datum){return datum;}},

onExit:{
duration:600,
before:function before(){return{opacity:0};}},

onEnter:{
duration:600,
before:function before(){return{opacity:0};},
after:function after(datum){return datum;}}};


}


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-util/default-transitions.js
// module id = 1485
// module chunks = 0